/* eslint-disable camelcase */
import axios from 'axios';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from "react-router-dom";
import * as Yup from 'yup';
import { addFlashMessage } from '../../../actions/flashMessages.actions';
import { USER } from '../../../utils/constants';
import '../SignIn/SignIn.scss';
import FormTemplate from '../Welcome/FormTemplate';

function ResetYourPassword({
  user = USER.INFLUENCERS
}) {

  const history = useHistory();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [state, setState] = useState({
    loading: false,
  });

  let { resetPasswordToken } = useParams();


  const validationSchema = Yup.object({
    password: Yup.string()
      .min(8, `${t('common.must_be_or_more', { num: 8 })}`)
      .required(`${t('common.forms.is_required')}`),
    passwordConfirmation: Yup.string()
      .oneOf([Yup.ref('password'), null], `${t('common.forms.passwords_must_match')}`)
      .required(`${t('common.forms.is_required')}`)
  });

  const formik = useFormik({
    initialValues: {
      password: '',
      passwordConfirmation: '',
    },
    validationSchema,
    onSubmit: values => {
      setState({ ...state, loading: true });
      let data = {
        user: {
          reset_password_token: resetPasswordToken,
          password: values.password,
          password_confirmation: values.passwordConfirmation,
        }
      };
      let endpoint = '/api/v1/influencers/users/password';
      // Change endpoint for agents
      if (user === USER.CLIENTS) {
        endpoint = '/api/v1/clients/agents/password';
        data['agent'] = data['user']
        delete data['user']
      }
      axios.put(endpoint, data)
        .then(({ data }) => {
          if (data.success) {
            dispatch(addFlashMessage({
              type: 'success',
              text: data.message
            }));
            history.push(user === USER.ADMINS ? '/team/signin' : '/');
          } else {
            dispatch(addFlashMessage({
              type: 'error',
              text: data.error
            }));
          }
          setState({ ...state, loading: false });
        }).catch(error => {
          console.log(error);
          setState({ ...state, loading: false });
        });
    },
  });

  return <FormTemplate title={t('common.pages.reset_your_password.set_new_password')}
    handleSubmit={formik.handleSubmit}
    submitText={t('common.pages.reset_your_password.set_password')}
    loading={state.loading} >
    <Form.Group className='mb-3'>
      <Form.Label>
        {t('common.pages.reset_your_password.new_password')}
      </Form.Label>
      <Form.Control
        type="password"
        placeholder={t('common.pages.reset_your_password.password_placeholder')}
        id="password"
        name="password"
        onChange={formik.handleChange}
        value={formik.values.password}
        autoComplete="false" />
      <Form.Text className="text-muted danger-text">
        {formik.errors.password}
      </Form.Text>
    </Form.Group>
    <Form.Group className='mb-3' >
      <Form.Label>
        {t('common.pages.reset_your_password.new_password_confirmation')}
      </Form.Label>
      <Form.Control
        type="password"
        placeholder={t('common.pages.reset_your_password.password_placeholder')}
        id="passwordConfirmation"
        name="passwordConfirmation"
        onChange={formik.handleChange}
        value={formik.values.passwordConfirmation}
        autoComplete="false" />
      <Form.Text className="text-muted danger-text">
        {formik.errors.passwordConfirmation}
      </Form.Text>
    </Form.Group>
  </FormTemplate>;
}

ResetYourPassword.propTypes = {
  user: PropTypes.string,
};

export default React.memo(ResetYourPassword);
